/**
 * Removes (strips) whitespace from both ends of the string.
 */
export const trim = (word: string): string => (word ? word.trim() : word);

/**
 * Make first char capitalized.
 */
export const capitalized = (word: string): string => (word ? word.charAt(0).toUpperCase() + word.slice(1) : word);

/**
 * Make first char of all words in string capitalized.
 */
const prefixes = " \u02BC\u2019'`-";
const expression = '(?:[{prefix}]|^)[^{prefix}]*'.replace(/\{prefix\}/g, prefixes);
export function capitalizeAll(text = ''): string {
    return text.replace(new RegExp(expression, 'g'), (word) => {
        const expression = new RegExp('[{prefix}]'.replace('{prefix}', prefixes), 'g');
        const prefixLength = word.search(expression) === -1 ? 1 : 2;
        return word.slice(0, prefixLength).toUpperCase() + word.slice(prefixLength).toLowerCase();
    });
}

/**
 * Convert camelCase to snake_case
 */
export const toSnakeCase = (type: string): string => {
    return type
        .split(/(?=[A-Z])/)
        .join('_')
        .toLowerCase();
};

/**
 * Convert string to UPPER_SNAKE_CASE
 */
export function toUpperSnake(type: string): string {
    return toSnakeCase(type).toUpperCase();
}
